<template>
  <div id="sskGuaranteeDetailPage">
    <div class="wrapper">
      <img class="head-img" src="https://pic.xiaobaibao.com/clause/2022/11/ace40092e880422fbd2110586fae6d2c.png" alt="" >
      <div id="detail-content5"></div>
    </div>
    <footer>
      <div class="footerUnit">
        <button type="button" class="goBack" @click="goTo()">返回</button>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "sskGuaranteeDetailPage",
    data() {
      return {
        planId: '',
        productId: '',
        ensureTypeId: '',
      }
    },
    methods: {
      goTo(){
        this.$router.go(-1);
      }
    },
    mounted() {
      let that = this;


    }
  }
</script>

<style scoped>
  /**
 * 穗岁康-查看保障详情 css
 * @Author 吴成林
 * @Date 2022-10-24 16:00
 */
  #sskGuaranteeDetailPage {
    max-width: 750px;
    margin: 0 auto;
    position: relative;
    width: 100%;
    height: 100%;
    background: #ffffff;
    overflow: auto;
    padding: 0 0 6rem;
  }

  #detail-content5{
    max-height: 446px;
    padding-top: 59.2%;
    background: url("../../../../static/images/product/ssk/details-5.png") no-repeat center / cover;
  }

  /* 底部 */
  footer{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 101;
    background: #ffffff;
    width: 100%;
  }
  .footerUnit{
    max-width: 750px;
    margin: 0 auto;
    text-align: center;
    height: 5rem;
    line-height: 5rem;
    display: flex;
  }

  .goBack{
    width: 100%;
    font-size: 1.5rem;
    background-color: #074f98;
    text-align: center;
    border-radius: 0.267vw;
    border: none;
    color: #fff;
    z-index: 100;
    flex: 1;
    max-width: 750px;
    margin: 0 auto;
    vertical-align: middle;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/ssk/guaranteeDetailPage.vue